import { createBufferedRequestFunction } from "@tm/utils"
import { showVehicles } from "./showVehicles"

export const getVehicleBuffered = createBufferedRequestFunction({
    callService: showVehicles,
    mapServiceResponseToResponse: (serviceResponse, request) => serviceResponse.find((v) => v.id === request),
})
